import { api } from '../plugins/axios_settings'

// Overtime overview store module. Talks to the timerapi microservice via the
// same `api` instance the calendar/flex modules use. Namespaced. The endpoint is
// scoped to the signed-in user and returns that user's 50% / 100% overtime
// totals (in minutes) plus the contributing entries for the chosen period.
const state = {
  overtimeOverview: {
    overtime_50_minutes: 0,
    overtime_100_minutes: 0,
    overtime_total_minutes: 0,
    entries: []
  }
}

const getters = {
  getOvertimeOverview: state => state.overtimeOverview
}

const mutations = {
  SET_OVERTIME_OVERVIEW (state, overview) {
    state.overtimeOverview = overview
  }
}

const actions = {
  GET_OVERTIME_OVERVIEW ({ commit }, params = {}) {
    const query = new URLSearchParams()
    if (params.from) query.append('from', params.from)
    if (params.to) query.append('to', params.to)
    const qs = query.toString()
    return new Promise((resolve, reject) => {
      api.get(`/overtime/overview${qs ? `?${qs}` : ''}`)
        .then((response) => {
          commit('SET_OVERTIME_OVERVIEW', response.data.data)
          resolve(response.data.data)
        })
        .catch(reject)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
